import { Box } from "@mui/material";
import { Alert } from "@platform/design-system";
import { useUser } from "@platform/user/client";

import { TIER_IN_TEXT } from "../tier";

import { RUMI_TESTER_ROLE } from "./signIn";
import { SignInPage } from "./SignInPage";

import type { ReactNode } from "react";

export const NO_ACCESS_TEST_ID = "golden-no-access";

/**
 * Renders the app only for a signed-in rumi-tester. The API enforces the role; this
 * only keeps everyone else off pages whose every request would fail.
 */
export const RumiTesterGate = ({
  children,
}: {
  readonly children: ReactNode;
}): ReactNode => {
  const { user } = useUser();
  if (user.status !== "signedIn") return <SignInPage />;
  if (!user.roles.includes(RUMI_TESTER_ROLE)) {
    return (
      <Box sx={{ p: 4 }}>
        <Alert
          data-testid={NO_ACCESS_TEST_ID}
          severity="warning"
          title="No access"
        >
          The {TIER_IN_TEXT} set needs the {RUMI_TESTER_ROLE} role. Ask an admin
          to add you to the RUMI testers group.
        </Alert>
      </Box>
    );
  }
  return children;
};
